export class LoginRequestVM {
    UserName:string= "";
    Password: string= "";
    RememberMe: boolean = true;
    AuthenticationType: string = "phone";
    attempt:any;
}
